var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForm3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.3541,
    height: 33.3541,
    rx: 16.6771,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9893 17.7143C15.1088 17.91 15.2506 18.0952 15.4147 18.266C16.4337 19.3265 17.9869 19.4923 19.1729 18.7634C19.3927 18.6283 19.5998 18.4625 19.7886 18.266L22.5224 15.4209C23.7301 14.1639 23.7301 12.1258 22.5224 10.8687C21.3145 9.6117 19.3562 9.61171 18.1484 10.8687L17.5463 11.4954",
    stroke: "#007E8C",
    strokeWidth: 1.03108,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.808 21.8586L15.2056 22.4854C13.9978 23.7425 12.0395 23.7425 10.8317 22.4854C9.62382 21.2283 9.62382 19.1903 10.8317 17.9333L13.5654 15.0882C14.7732 13.8311 16.7315 13.8311 17.9393 15.0882C18.1034 15.2589 18.2452 15.4441 18.3647 15.6397",
    stroke: "#007E8C",
    strokeWidth: 1.03108,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm3);
export default __webpack_public_path__ + "static/media/form-3.17156fba7bff7e91c6a7c5e3b266037f.svg";
export { ForwardRef as ReactComponent };